module.exports = __webpack_public_path__ + "static/img/partner-logo-13.358739a6.png";